import script from "./sat.vue?vue&type=script&setup=true&lang=js"
export * from "./sat.vue?vue&type=script&setup=true&lang=js"

import "./sat.vue?vue&type=style&index=0&id=6d1d1cf4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1d1cf4"]])

export default __exports__